// frontend/src/ui/MenuCard.jsx
import React from "react";

export default function MenuCard({
  id,
  text,
  disabled = false,
  title = "",
  onClick,
}) {
  const style = disabled ? { opacity: 0.55, cursor: "not-allowed" } : undefined;

  return (
    <button
      className="menu-card"
      onClick={onClick}
      disabled={disabled}
      title={title}
      style={style}
    >
      <span className="menu-id">{id}.</span>
      <span className="menu-text">{text}</span>
    </button>
  );
}
